export default function PHP_ezmlm_hash() {
  return (
    <div>
      <h1>PHP_ezmlm_hash</h1>
    </div>
  );
}
